import {Link} from 'react-router-dom';

function ResetPasswordSuccessMain() {
    return (
        <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 relative">
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none overflow-hidden">
                <img className="w-full h-full object-cover" data-alt="Abstract dark racing track with motion blur" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBKqQz6UAyrrEQWu4miwbFSmBOAlwzRfW8LLitvVxaVavpDtcuSlJgt-iItw2dUTQ-BYp6frvs4tu9gDOpPaQAreXd6GJRA1iqmChzNW4UD6BJPqQ3O7SNvDKyt7hfWEQ8lrf1_zImFpC4VmbH_XHzSCl4ue-huzMhh0Gz34vH__A3cZ82mfq0uyAPfEEZ2JgDPqzz98o48HYWN4Rl2nXKP74ERx4YWVaMNSem4BNfOa2iKnNSfm2O7czVGrhjBFmEyFjdmUilj2Jo" />
            </div>
            <div className="w-full max-w-[480px] z-10">
                <div className="glass-card rounded-xl p-10 shadow-2xl text-center">
                    <div className="mb-8 relative inline-block">
                        <div className="success-glow inline-flex items-center justify-center size-24 rounded-full bg-success/10 border-2 border-success/30">
                            <span className="material-symbols-outlined text-success text-5xl font-bold">check</span>
                        </div>
                    </div>
                    <h1 className="text-white tracking-tight text-3xl font-bold leading-tight mb-4">Password Successfully Updated</h1>
                    <p className="text-white/60 text-base font-normal leading-relaxed mb-5 max-w-sm mx-auto">
                        Your driver profile is now secure. You can now log in with your new credentials.
                    </p>
                    <p className="text-white/60 text-base leading-relaxed mb-10 max-w-sm mx-auto font-bold">
                        We've closed all the sessions connected to your account.
                    </p>
                    <div className="space-y-4">
                        <Link to="/login">
                            <button className="w-full bg-primary hover:bg-primary/80 text-white font-bold py-4 rounded-lg shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 group">
                                Go to Login
                                <span className="material-symbols-outlined text-xl group-hover:translate-x-1 transition-transform">login</span>
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="mt-8 text-center">
                    <p className="text-white/30 text-xs flex items-center justify-center gap-2">
                        <span className="material-symbols-outlined text-sm">verified_user</span>
                        Security update completed successfully
                    </p>
                </div>
            </div>
        </main>
    );
}

export default ResetPasswordSuccessMain;